import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { QRCodeResponse } from '../../responses/totem/qr-code.reponse';

@Injectable({
  providedIn: 'root'
})
export class QRCodeInternalService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getvalidateQRCodeByGuid(guid: string): Observable<QRCodeResponse> {

    let uri = `QRCodeInternal/guid/${guid}`;

    return this.httpClient.patch<QRCodeResponse>(environment.urlApiTotem + uri, null, this.addHeaderHash())
      .pipe(catchError(this.handleError));
  }
}